import { Coordinates, PolygonGeometry } from 'interfaces/vector.interface';

// taking approx. half the distance(in metres) from center of map to corner of the screen
export const ZOOM_RADIUS_MAP: Record<string, number> = {
	15: 1437.24,
	16: 720.75,
	17: 358.83,
	18: 180.5,
	19: 88.24,
};

const getPolygonVertexIndexClosestToCenter = (
	center: Coordinates,
	polygonGeometry: PolygonGeometry,
	zoom: number,
): number => {
	let index = 0;
	let radius: number = ZOOM_RADIUS_MAP[`${zoom}`];

	for (let i = 0; i < polygonGeometry.length; i++) {
		let distanceFromCenter =
			google.maps.geometry.spherical.computeDistanceBetween(
				new google.maps.LatLng(polygonGeometry[i]),
				new google.maps.LatLng(center),
			);
		if (distanceFromCenter <= radius) {
			index = i;
			break;
		}
	}
	return index;
};

export default getPolygonVertexIndexClosestToCenter;
